
$(function(){
    if($('#search-page').length>0) {
        search.init();
    }
});


var search = {
    ajaxMethod: 'GET',
    ajaxUrl : '/ajaxRequest/search/filter',
    filterForm: {},
    target: {},
    uriObj: {},
    init: function() {
        console.log('search.init()');

        $('#search-page .filter-link').click(search.filterLinkClick);
        $('#search-page .filterOnChange').change(search.filterOnChange);

        $('#search-page .search-filters .navbar-nav > .dropdown').on('hide.bs.dropdown', search.keepDropdownFilterOpen);

        $('#searchTabForm button').on('click', search.onClickSearchTabButton);

        this.filterForm = $('form#filter');
        this.target = $('#asyncPlaceholder');
        this.uriObj = this.getUriParameters();

        this.uriObj.listview = 'newbuild';

        if(this.uriObj.category == 'is_webshop') {
            $('.is-webshop').removeClass("d-none");
        }

        if(typeof this.uriObj.is_photo === 'undefined') {
            this.uriObj.is_photo = $('#loadButton').data('photo')?$('#loadButton').data('photo'):'';
        }

        search._initArtistAutoComplete();
        search.initTagAutoComplete();
        
        console.log(this.uriObj);

        search.changeLimit();
        search.changeFilterVisibility();

        this.loadResult(this.uriObj);
    },
    loadResult: function(data) {
        if(data.tabid == "") {
            data.tabid = "creation";
        }

        $('#loadButton').data('request-data', data);
        $('#loadButton').data('pagecnt', 0);
        loadMore.click($('#loadButton'), search.onLoadResult);
        $('#loadButton').show();
        search.changeFilterVisibility();

    },

    onLoadResult: function(data) {
        console.log('onloadresult', data);

        if(typeof data.artist_result_count == "string" || typeof data.artist_result_count == "number") {
            $('#artistResultCount').html(data.artist_result_count);
        }
        if(typeof data.creation_result_count == "string" || typeof data.creation_result_count == "number") {
            $('#creationResultCount').html(data.creation_result_count);
        }
        if(typeof data.creation_count_new == "string" || typeof data.creation_count_new == "number") {
            $('#new_creationCreationResultCount').html(data.creation_count_new);
        }
        if(typeof data.photographer_result_count == "string" || typeof data.photographer_result_count == "number") {
            $('#photographerResultCount').html(data.photographer_result_count);
        }
        if(typeof data.photo_result_count == "string" || typeof data.photo_result_count == "number") {
            $('#photoResultCount').html(data.photo_result_count);
        }
    },
    getUriParameters : function() {
        return (document.location.search).replace(/(^\?)/,'').split("&").map(function(n){return n = n.split("="),this[n[0]] = decodeURIComponent(n[1]),this}.bind({}))[0];
    },

    keepDropdownFilterOpen: function(event) {
        var filter = $(event.target).data('filter');
        if(search.uriObj[filter]) {
            return false;
        }
        return true;
    },

    filterLinkClick: function(event) {
        event.stopPropagation();
        event.preventDefault();

        var filter = $(event.target).data('filter');
        var value = $(event.target).data('value');

        $(event.target).closest('.dropdown-menu').find('.nav-link.active').removeClass('active');

        if(search.uriObj[filter] == value) {
            search.uriObj[filter] = '';
        } else {
            search.uriObj[filter] = value;
            $(event.target).addClass('active');
        }
        search.loadResult(search.uriObj);

        console.log('filterLinkClick',event.target);
    },
    filterOnChange: function(event) {
        var filter = $(event.target).prop('name');
        var value = $(event.target).val();

        if(filter == "CUR") {
            $('.price-filter .filter-link').addClass("d-none");
            $('.price-filter .' + value).removeClass("d-none");
        }

        search.uriObj[filter] = value;
        search.loadResult(search.uriObj);
    },
    _initArtistAutoComplete : function(){
        // művész szűrő
        var no_result = $('.searchArtistAutoComplete').data('no_res');
        var sArtistAutoComplete = $('.searchArtistAutoComplete').selectize({
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            create: false,
            load: function(query, callback) {
                if (!query.length) return callback();
                $.ajax({
                    url: '/ajaxRequest/artist/findByTerm?term=' + encodeURIComponent(query) + ((search.uriObj.category == 'is_webshop')?'&ws=1':'')+ ((search.uriObj.category == 'is_db')?'&db=1':'') + '&is_photo='+(search.uriObj.is_photo?1:0), // $('input[name=is_photo]').val()
                    type: 'GET',
                    dataType: 'json',
                    beforeSend: function(){
                        $(".searchArtistAutoComplete.selectize-dropdown").find('.no_result').remove();
                    },
                    error: function() {
                        callback();
                    },
                    success: function(resp) {
                        if(resp.data) {
                            callback(resp.data);
                        }
                        else{
                            $(".searchArtistAutoComplete.selectize-dropdown").append("<div class='no_result' style='padding: 3px'>"+no_result+" ("+query+")</div>").show();
                        }
                    }
                })

            },
            onType: function(str){
                if(str == ""){
                    this.clearOptions();
                }
            },
            onChange: function(x){
                if(x == ""){
                    this.clearOptions();
                }
            },
            render: {
                item: function(item, escape) {
                    return '<div>' +
                        (item.name.length > 25 ? item.name.substring(0,25)+'...' : escape(item.name)) +'</div>';
                }
            }
        });
        if(sArtistAutoComplete.length) {
            var sArtistAutoCompleteControl = sArtistAutoComplete[0].selectize;
            $('.searchArtistAutoComplete').on('clearSelect', function () {
                sArtistAutoCompleteControl.clear(true);
            });
        }
    },
    initTagAutoComplete: function() {
        var tagAutoComplete = $('.tagAutoComplete').selectize({
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            create: false,
            load: function(query, callback) {
                if (!query.length) return callback();
                $.ajax({
                    url: '/ajaxRequest/tag/findByTerm?term=' + encodeURIComponent(query) + ((search.uriObj.category == 'is_webshop')?'&ws=1':'')+ ((search.uriObj.category == 'is_db')?'&db=1':''),
                    type: 'GET',
                    dataType: 'json',
                    error: function() {
                        callback();
                    },
                    success: function(resp) {
                        console.log(resp);
                        callback(resp.data);
                    }
                });
            },
            render: {
                item: function(item, escape) {
                    console.log(item);
                    return '<div>' +
                        (item.name.length > 25 ? item.name.substring(0,25)+'...' : escape(item.name)) +'</div>';
                }
            }
        });
        if(tagAutoComplete.length) {
            var tagAutoCompleteControl = tagAutoComplete[0].selectize;
            $('.tagAutoComplete').on('clearSelect', function () {
                tagAutoCompleteControl.clear(true);
            });
        }
    },
    onClickSearchTabButton: function(event) {
        var button = $(event.target).prop('tagname')=="BUTTON"?$(event.target):$(event.target).closest("button");
        search.uriObj.tabid = button.val();
        search.uriObj.is_photo = button.data('photo') ? '1' : '';
        search.changeLimit();

        console.log('onClickSearchTabButton', search.uriObj.tabid);
        if(!button.hasClass('btn-gray')) {
            $('#searchTabForm button.btn-gray').removeClass("btn-gray").addClass("btn-outline-gray");
            button.removeClass("btn-outline-gray").addClass("btn-gray");
        }
        search.loadResult(search.uriObj);

        return false;
    },
    // collector, artist esetén nem kell filter
    changeFilterVisibility: function() {
        if(search.uriObj.tabid == "artist" || search.uriObj.tabid == "collector" || search.uriObj.tabid == "photographer") {
            $("#colSearchFilter").addClass("d-none");
            $("#colSearchResult").removeClass("col-9").addClass("col-12");
        } else {
            $("#colSearchFilter").removeClass("d-none");
            $("#colSearchResult").removeClass("col-12").addClass("col-9");
        }
    },

    changeLimit: function() {
        if(search.uriObj.tabid == "artist" || search.uriObj.tabid == "collector" || search.uriObj.tabid == "photographer") {
            this.uriObj.limit = 8;
        } else {
            this.uriObj.limit = 6;
        }
        $("#loadButton").data("limit", this.uriObj.limit);
        console.log('limit', $("#loadButton").data("limit"));
    }
}